/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const getKey = (prefix) => {
    if (!prefix) {
        prefix = "key_";
    } else {
        prefix = `${prefix}_`;
    }
    // const key = crypto.randomUUID()
    const key = generateID();
    return `${prefix}${key}`;
};
const makeKey = (prefix, key) => {
    if (!prefix) {
        prefix = "key_";
    } else {
        prefix = `${prefix}_`;
    }
    return `${prefix}${key}`;
};

const generateID = () => {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
};

export {
    getKey,
    makeKey,
};
